<gp-modal [closable]="false" #createPopup>
  <div class="gp-modal-title">
    {{ 'SETTINGS.user_rights.create_user' | translate }}
  </div>
  <form [formGroup]="createAdminUserForm" novalidate class="gp-modal-body clearfix">
    <div class="col-md-12">
      <div class="form-group">
        <label for="firstName">{{ 'FORMS.first_name' | translate }}
          <span class="required"> *</span>
        </label>
        <div class="input-group">
          <input type="text" class="form-control" formControlName="firstName" id="firstName">
        </div>
        <ul class="error-list"
            [attr.data-hidden]="createAdminUserForm.valid || createAdminUserForm.pristine">
        </ul>
      </div>
      <div class="form-group">
        <label for="lastName">{{ 'FORMS.last_name' | translate }}
          <span class="required"> *</span>
        </label>
        <div class="input-group">
          <input type="text" class="form-control" formControlName="lastName" id="lastName">
        </div>
        <ul class="error-list"
            [attr.data-hidden]="createAdminUserForm.valid || createAdminUserForm.pristine">
        </ul>
      </div>
      <div class="form-group">
        <label for="email">{{ 'EMPLOYEE_HIRE.personal_email' | translate }}
          <span class="required"> *</span>
        </label>
        <div class="input-group">
          <input type="text" class="form-control" mvel-alias="GP_CREATE_USER_EMAIL" formControlName="email" id="email">
        </div>
        <ul class="error-list"
            [attr.data-hidden]="createAdminUserForm.valid || createAdminUserForm.pristine">
          <li *ngIf="this.createAdminUserForm.get('email').hasError('invalidEmailAddress')">
            {{ 'FORMS.VALIDATORS.invalid_email' | translate }}
          </li>
          <li *ngIf="isEmployee && this.createAdminUserForm.get('email').hasError('emailExists')">
            {{ 'FORMS.VALIDATORS.email_exists_for_employee_within_company' | translate }}
          </li>
          <li *ngIf="!isEmployee && this.createAdminUserForm.get('email').hasError('emailExists')">
            {{ 'FORMS.VALIDATORS.email_exists_for_user' | translate }}
          </li>
        </ul>
      </div>
      <div class="form-group">
        <label for="profile">{{ 'SETTINGS.profile' | translate }}
          <span class="required"> *</span>
        </label>
        <div class="input-group">
          <ng-select class="entity-list-filter"
                      [formControl]="profileNameFormControl"
                      [items]="profileArray"
                      ngDefaultControl>
          </ng-select>
        </div>
        <ul class="error-list"
            [attr.data-hidden]="createAdminUserForm.valid || createAdminUserForm.pristine">
        </ul>
      </div>
      <div *ngIf="loading" class="gp-modal-footer">
        <div class="pull-left">
          <i class="fa fa-light fa-spinner fa-spin" aria-hidden="true"></i>
        </div>
      </div>
    </div>
  </form>

  <div class="gp-modal-footer">
    <div class="btn-bar-wrapper">
      <div class="btn-bar btn-bar-sm btn-bar-align-end">
        <button type="submit"
                class="btn btn-dark p-x-md"
                (click)="onSubmit()"
                [disabled]="createAdminUserForm?.invalid || loading">
          {{ 'EMPLOYEE_FORM.submit' | translate }}
        </button>
        <button type="button"
                class="btn btn-secondary p-x-md"
                (click)="createPopup.close()">
          {{ 'FORMS.cancel' | translate }}
        </button>
      </div>
    </div>
  </div>

</gp-modal>
